












import Vue from "vue";

// Import External Components
import FormText from "@miele/component-library-vue/src/components/elements/form/TextInput.vue";

export default Vue.extend({
  name: "SearchContainer",
  components: {
    FormText,
  },
  computed: {
    translations() {
      return this.$store.state.translations;
    },
    value() {
      return this.$store.state.searchParams.search;
    },
  },
  methods: {
    async changeFunction(event: any) {
      const value: string = event.target.value;
      await this.$store.dispatch("updateSearchValue", value);
    },
  },
});
